import {t} from "../../../_i18n";
import {Fragment, h} from "preact";
import {AppPage} from "../../../_common/components/app-page";
import {C, F} from "../../../_common/layout";
import {useHistory, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import { Field, Form as FinalForm } from 'react-final-form';
import {isMobileAgent} from "../../../_common/common";
import {useEffect, useState} from "preact/hooks";
import {toastService} from "../../../_services/toast-service";
import {
  allDocumentsDeliveryConfirmation,
  fetchDocumentsMeta,
  fetchProtoMeta,
  postProtoMeta
} from "../../../_rx/exemption100-CATMAD-2425/actions";
import {FormField, FormFieldRadioCheckboxList} from "../../../_common/forms/components/components";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";
import UploadDocument from "../../components/UploadDocument/UploadDocument";
import {validationDocumentFCT} from "../../components/UploadDocument/validationDocumentFCT";
import {ButtonGhost} from "../../../_common/components/buttons/buttons";
import ButtonSpinner from "../../../_common/components/buttons/buttonSpinner/buttonSpinner";
import {Link} from "react-router-dom";
import './ExemptionCATMAD2425.scss';
import AlertContact from "../../components/Alerts/AlertContact";
import SignAddress from "../../components/SignAddress/SignAddress";

export function ExemptionCATMAD2425 () {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const isMobile = isMobileAgent();
  const [loading, setLoading] = useState(true);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isLoadingDraft, setIsLoadingDraft] = useState(false);
  const formativeZoneCode = useSelector(state => state.status.student_meta.formative_zone_code);
  const signedConditions = useSelector(state => state.status.student_meta.signed);

  const { proto_meta, documents_meta, static_documents } = useSelector(state => ({
    proto_meta: state.exemption_100.proto_meta,
    documents_meta: state.exemption_100.documents_meta,
    static_documents:  state.fct.static_documents
  }));

  const loadPrecontracts = async () => {
    try {
      setLoading(true);
      await dispatch(fetchProtoMeta(id));
      await dispatch(fetchDocumentsMeta(id));
    } catch (error) {
      toastService.showToast({ message: t("Error al cargar los precontracts."), type: 'danger' });
    } finally {
      setLoading(false);
    }
  };


  const work_types = [
    {key: 'work_others', name: 'Trabajador por cuenta ajena'},
    {key: 'freelance', name: 'Autónomo/a'},
  ]

  useEffect(() => {
   loadPrecontracts().then();
  }, []);

  const scroll = () => {
    setTimeout(() => {
      const el = document.querySelector('.error');
      el && el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  }

  const handleExemptionCheck = (val, form) => {
    if (!val) {
      form.change('proto_meta.type', '')
    }
  }

  const savePrototMeta = async (values) => {
    setIsLoadingDraft(true);
    try {
      await postProtoMeta(id, values);
    } catch (error) {
      toastService.showToast({ message: "No se pudo guardar.", type: "danger" });
    } finally {
      setIsLoadingDraft(false);
    }
  };


  const submitForm = async (values) => {
    setIsLoadingSubmit(true);
    try {
      await allDocumentsDeliveryConfirmation(id);
      toastService.showToast({ message: "Documentación enviada correctamente.", type: "info" });
      history.push('./..');
    } catch (error) {
      toastService.showToast({ message: "No se pudo guardar.", type: "danger" });
    } finally {
      setIsLoadingSubmit(false);
    }
  }

  if (!proto_meta) return <div />
  if (proto_meta && signedConditions) return <F className='max-width-980 m-top-x2'>
    <p>{t('Si tienes alguna duda puedes')}
      <Link to={{pathname: `/fct/${id}/normativa`}} className='txt-color-primary t-underline font-medium'></Link>.
    </p>
  </F>
  if (proto_meta.status === 1) return <F className='max-width-980 m-top-x2'>
    <AlertBox type={"info"} className='m-top max-width-980'>
      <span>{t('Hemos recibido la documentación')}</span>
    </AlertBox>
    <AlertContact/>
  </F>
  if (proto_meta.status === 2 && !loading) return <F className='max-width-980 m-top-x2'>
    <AlertBox type={"info"} className='m-top max-width-980'>
      <span>{t('Tras revisar tu documentación')}</span>
    </AlertBox>
    {documents_meta && (documents_meta.tasks === null || !documents_meta.tasks?.digital_signed) && <AlertBox type={"warning"} className="m-top max-width-980">
      <span>{t('Para que podamos tramitar tu exención, necesitamos que envíes por correo postal el certificado de tareas con firma y sello originales a la siguiente dirección:')}</span>
      <SignAddress className='m-top' />
    </AlertBox>
    }
    <AlertContact/>
  </F>
  return <Fragment>
    {loading ?
      <p className="t-center m-top-x2">
        <em className="disabled-aspect-gray"> {t('Cargando')}. . . </em>
      </p>
     : <AppPage
          name={t('Exención')}
          back={history.goBack}
          className="max-width-980"
      >
        <F className="max-width-980">
          <C>
            <h1 className='hero m-top'>{t('Exención')}</h1>
            <p>{t('Si tienes experiencia laboral previa, puedes solicitar una reducción o exención total de las horas de tus prácticas en empresas. Para hacerlo, deberás demostrar una experiencia mínima relacionada con el ciclo formativo que estás cursando. El claustro de profesores evaluará la documentación que envíes y te informará sobre el tipo de exención que se te pueda conceder.')}</p>
            <ul>
              <li>
                {t('percent_exemption_100')}
                { proto_meta.contributed_days_100
                    ? <span dangerouslySetInnerHTML={{__html: t('dias_cotizados').replace('{percent_days}', proto_meta.contributed_days_100)}} />
                    : ''
                }
              </li>
            </ul>
            <FinalForm
                onSubmit={submitForm}
                initialValues={{proto_meta, documents_meta}}
                render={({handleSubmit, values, form, submitFailed, ...props}) => {
                  return (
                      <form action="" onSubmit={handleSubmit} noValidate>
                        {submitFailed && !props.dirtySinceLastSubmit && scroll()}
                        <div>
                          <AlertBox type='shadow'>
                            <div>
                              <FormField
                                  name='proto_meta.check'
                                  label={t('Solicitar exención')}
                                  type='checkbox'
                                  required
                                  onChange={(val) => handleExemptionCheck(val, form)}
                              />
                            </div>
                            {values.proto_meta.check && (
                                <div>
                                  <div className='m-top-x2'>
                                    <FormFieldRadioCheckboxList
                                        name='proto_meta.type'
                                        options={work_types}
                                        required
                                        label={<span dangerouslySetInnerHTML={{__html: t('exemption_work_types_label')}}/>}
                                        specificError={t('Por favor, indica que tipo de experiencia laboral has tenido.')}
                                        onChange={(val) => savePrototMeta({
                                          ...values.proto_meta,
                                          type: val
                                        })}
                                    />
                                  </div>
                                  <AlertBox type='dashed' className='m-top'>
                                    <p>{t('Deberás proporcionar los documentos que acrediten tu experiencia laboral.')}</p>
                                    <p>{t('Una vez que el claustro de profesores evalúe tu caso, se te otorgará el porcentaje correspondiente.')}</p>
                                  </AlertBox>
                                </div>
                            )}
                          </AlertBox>
                          {(values.proto_meta.type === 'work_others' || values.proto_meta.type === 'freelance') &&
                              <Fragment>
                                <h1 className='m-top-x2'>{t('Documentos')}</h1>
                                <p>{t('Los documentos aportados deben estar en formato PDF.')}<br/>
                                  {t('Puedes utilizar la web')} <a href="https://www.ilovepdf.com/es" target="_blank">ILOVEPDF</a> {t('o cualquier otra herramienta de conversión de documentos online si tu formato no coincide.')}
                                </p>
                                <Field
                                    name='documents_meta.work_life'
                                    label={t('Informe de vida laboral')}
                                    component={UploadDocument}
                                    precontractId={id}
                                    description={<span dangerouslySetInnerHTML={{__html: t('work_life_label')}}/>}
                                    specificError={t('Por favor, agrega el informe de vida laboral.')}
                                    typeDocument='work_life'
                                    className='m-x2-top'
                                    required
                                    validate={validationDocumentFCT}
                                />
                                {(values.proto_meta.type === 'work_others') &&
                                    <Fragment>
                                      <Field
                                          name='documents_meta.tasks'
                                          label={t('Certificado de tareas')}
                                          component={UploadDocument}
                                          description={
                                            <span>
                                      {t('Descarga la plantilla:')} <a href={static_documents.tasks.url}
                                                                       className='font-color-149BAB'> Certificado de tareas </a>.
                                              {t('Complétala y luego vuelve a subirla.')}
                                              <AlertBox type={"info"} className="m-top m-bottom">
                                          {t('fct_international_help')}
                                                <a href={t('fct_cert_tareas_international_help_document_link')}> {t('fct_cert_tareas_international_help_document')}. </a>
                                        </AlertBox>
                                    </span>
                                          }
                                          specificError={t('Por favor, agrega el certificado de tareas.')}
                                          typeDocument='tasks'
                                          className='m-x2-top'
                                          precontractId={id}
                                          required
                                          validate={validationDocumentFCT}
                                      />
                                    </Fragment>
                                }
                                {(values.proto_meta.type === 'freelance') && (
                                    <Fragment>
                                      <Field
                                          name='documents_meta.economic_activity'
                                          label={t('Certificado de alta de la actividad económica')}
                                          component={UploadDocument}
                                          specificError={t('Por favor, agrega el certificado de alta de la actividad económica.')}
                                          description={<span
                                              dangerouslySetInnerHTML={{__html: t('economic_activity_label')}}/>}
                                          typeDocument='economic_activity'
                                          precontractId={id}
                                          className='m-x2-top'
                                          required
                                          validate={validationDocumentFCT}
                                      />
                                      {formativeZoneCode.toUpperCase() === 'CAT2425' && (
                                          <Fragment>
                                            <Field
                                                name='documents_meta.contribution'
                                                label={t('Recibo de cotización en la Seguridad Social')}
                                                component={UploadDocument}
                                                description={t('Sube el recibo más actual.')}
                                                specificError={t('Por favor, agrega el recibo de cotización en la seguridad social.')}
                                                typeDocument='contribution'
                                                precontractId={id}
                                                className='m-x2-top'
                                                required
                                                validate={validationDocumentFCT}
                                            />
                                            <Field
                                                name='documents_meta.fee'
                                                label={t('Cuota de Régimen de Autónomo')}
                                                component={UploadDocument}
                                                description={<span dangerouslySetInnerHTML={{__html: t('fee_label')}}/>}
                                                specificError={t('Por favor, agrega la cuota de régimen de autónomo.')}
                                                typeDocument='fee'
                                                className='m-x2-top'
                                                precontractId={id}
                                                required
                                                validate={validationDocumentFCT}
                                            />
                                            <Field
                                                name='documents_meta.model130'
                                                label={t('Declaración trimestral (modelo 130)')}
                                                component={UploadDocument}
                                                description={<span
                                                    dangerouslySetInnerHTML={{__html: t('model130_label')}}/>}
                                                typeDocument='model130'
                                                specificError={t('Por favor,agrega el modelo 130 de la declaración trimestral.')}
                                                className='m-x2-top'
                                                precontractId={id}
                                                required
                                                validate={validationDocumentFCT}
                                            />
                                          </Fragment>
                                      )}
                                      {formativeZoneCode.toUpperCase() === 'MAD2425' && (
                                          <Field
                                              name='documents_meta.affidavit'
                                              label={t('Declaración jurada')}
                                              component={UploadDocument}
                                              description={
                                                <span>{t('Descarga la plantilla:')}
                                                  <a href={static_documents.affidavit.url} className='font-color-149BAB'> Declaración jurada </a>.
                                                  {t('Complétala y luego vuelve a subirla.')}
                                                  <AlertBox type={"info"}>
                                            {t('fct_international_help')}
                                                    <a href={t('fct_declaracion_jurada_help_document_link')}>{t('fct_declaracion_jurada_international_help_document')}.</a>
                                          </AlertBox>
                                        </span>
                                              }
                                              specificError='Por favor, agrega la declaración jurada.'
                                              typeDocument='affidavit'
                                              precontractId={id}
                                              className='m-x2-top'
                                              required
                                              validate={validationDocumentFCT}
                                          />
                                      )}
                                    </Fragment>
                                )}
                              </Fragment>
                          }
                        </div>
                        <div className='m-top-x2'>
                          <hr className="separator-xxs"/>
                          <div className='exemption-button-bar'>
                            <div className='save-draft'>
                              {isLoadingDraft
                                  ? <Fragment>
                                    <i className="fal fa-spinner-third loading"/>
                                    <span>{t('Guardando')}...</span>
                                  </Fragment>
                                  : <Fragment>
                                    <i className="fal fa-check-circle"/>
                                    <span>{t('Cambios guardados')}</span>
                                  </Fragment>
                              }
                            </div>
                            <div className='button-section'>
                              <Link to='./..'><ButtonGhost type='button'> {t('Salir')} </ButtonGhost></Link>
                              <div>
                                <ButtonSpinner
                                    type='submit'
                                    showSpinner={isLoadingSubmit}
                                    disabled={!values.proto_meta.check}
                                > {t('Enviar documentación')} </ButtonSpinner>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                  );
                }}
            />
          </C>
        </F>
      </AppPage>
    }
  </Fragment>
}
